import { Link } from "react-router-dom";

interface LinkButtonProps {
    to: string;
    children: React.ReactNode;
}

const LinkButton = ({ to, children }: LinkButtonProps) => {
    return (
        <Link
            className="flex items-center justify-between py-4 border-b border-zinc-700 text-zinc-300 hover:text-white text-lg transition-colors duration-150 group"
            to={to}
        >
            <span>{children}</span>
            <span className="text-zinc-500 group-hover:text-zinc-200 transition-colors duration-150">→</span>
        </Link>
    );
};

export default LinkButton;
